    (function(document,navigator,standalone) {                          
       //if (standalone in navigator && navigator[standalone]) {         
        var curnode,location=document.location,stop=/^(a|html)$/i;  
        document.addEventListener("click", function(e) {            
            curnode=e.target;                                       
            while (!stop.test(curnode.nodeName)) {                  
                curnode=curnode.parentNode;                         
            }                                                       
            if ("href" in curnode && (curnode.href.indexOf("http") || ~curnode.href.indexOf(location.host)) && curnode.target == false) {
                e.preventDefault(); 
                
                if( curnode.href == '') return false;

                if( curnode.href.substr(curnode.href.lastIndexOf('/') + 1) == 'javascript:;') return false;
                
                console.log('curnode', curnode.href);
                 $(".card").css('animation', 'hideCard .1s');
                setTimeout(function() {
                    location.href=curnode.href;
                }, 100);

                // var dtotal = 50;
                // $($(".card").get().reverse()).each(function(index) {
                //      var self = this;
                //     setTimeout(function() {
                //         $(self).css('animation', 'hideCard .1s');
                //     }, index * 50);
                //      dtotal = dtotal + 50;
                // });
                // setTimeout(function() {
                //     location.href=curnode.href;
                // }, dtotal);

            }                                                       
        },false);                                                   
       // }                                                               
   })(document,window.navigator,"standalone");



// WEBPACK FOOTER //
// ./resources/js/hrefs.js